import { render, staticRenderFns } from "./Post_Updates_Component.vue?vue&type=template&id=330bfd86&scoped=true"
import script from "./Post_Updates_Component.vue?vue&type=script&lang=js"
export * from "./Post_Updates_Component.vue?vue&type=script&lang=js"
import style0 from "./Post_Updates_Component.vue?vue&type=style&index=0&id=330bfd86&prod&scoped=true&lang=css"
import style1 from "./Post_Updates_Component.vue?vue&type=style&index=1&id=330bfd86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330bfd86",
  null
  
)

export default component.exports